import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import EditorialPreview from "./EditorialPreview";

const API_URL = (
  process.env.REACT_APP_API_URL || "https://zedro-backend.onrender.com"
).replace(/\/$/, "");

export default function EditorialPublicPage() {
  const { slug } = useParams();

  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const load = async () => {
      try {
        const res = await fetch(
          `${API_URL}/api/editorials/public/slug/${slug}`
        );

        if (!res.ok) throw new Error("not_found");

        const json = await res.json();
        setData(json);

      } catch (err) {
        console.error(err);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    load();
  }, [slug]);

  if (loading) return <div style={{ padding: 40 }}>Cargando...</div>;

  if (!data) return <div style={{ padding: 40 }}>Editorial no encontrada</div>;

  return (
    <div style={{ background: "#f8fafc", minHeight: "100vh", padding: "40px 0" }}>
      <div style={{ maxWidth: 720, margin: "0 auto" }}>
        <EditorialPreview data={data} />
      </div>
    </div>
  );
}
